import { Component, Input } from '@angular/core';

/**ToDo Documentazione */
@Component({
  selector: 'app-carousel-images',
  styleUrls: ['./carousel-images.component.scss'],
  templateUrl: './carousel-images.component.html'
})
export class CarouselImagesComponent {
  public activeIndex = 0;
  public displayCustom = false;
  @Input() public images!: string[];
  public responsiveOptions: any[] = [
    {
      breakpoint: '1024px',
      numVisible: 5
    },
    {
      breakpoint: '768px',
      numVisible: 3
    },
    {
      breakpoint: '560px',
      numVisible: 1
    }
  ];

  public errorHandler(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    const parentElement = imgElement.parentElement;
    imgElement.style.display = 'none';

    if (parentElement) {
        const images = parentElement.querySelectorAll('img');
        const allHidden = Array.from(images).every(img => img.style.display === 'none');
        if (allHidden) {
            parentElement.style.display = 'none';
        }
    }
  }

  public imageClick(index: number) {
    this.activeIndex = index;
    this.displayCustom = true;
  }
}
